import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { AuthenticationService } from '../services/authentication/authentication.service';
import { Router } from '@angular/router';
import { NotificationService } from '../services/notification/notification.service';

@Component({
  selector: 'app-dashboard',
  templateUrl: './forgot-passsword.component.html',
  styleUrls: ['./forgot-passsword.component.scss']
})
export class ForgotPassswordComponent implements OnInit {

  resetForm: FormGroup;
  submitted = false;
  message: string = '';
  error = '';

  constructor(
    private formBuilder: FormBuilder,
    private authenticationService: AuthenticationService,
    private router: Router,
    private _notificationservice: NotificationService
  ) { }

  ngOnInit() {
    this.resetForm = this.formBuilder.group({
      email: ['', Validators.required]
    });

  }

  onSubmit(){
    if (this.resetForm.value.email == 'sales@bookkeeperapp.net')
    {
      this.message = 'Not allowed'
    }
    else
    {
      this.message = '';
      this.submitted = true;
      this.authenticationService.forgetPassword(this.resetForm.value).subscribe(
        result => {
          this._notificationservice.success(result.message);
          this.submitted = false;
        }, error => {
          this._notificationservice.error('There were some issues at the server');
          this.submitted = false;
        }
      );
    }
  }

  navigateToLogin(){
    this.router.navigate(['/login']);
  }

}
